export const strongPasswordValidationMessage =
  'Password must be at least 8 characters and contain at least one uppercase, lowercase, number and special character (#?!@$%^&*-)';

export const mismatchedPasswordValidationMessage =
  "The passwords don't match. Please re-enter them.";
